import React from "react";
import ShoppingListCard from "./ShoppingListCard";
import EmptyList from "./EmptyList";
import { useLocation, useParams } from "react-router-dom";
import { UserAuth } from "../Context";
import ShoppingListCard2 from "./ShoppingListCard2";

const ProductList2 = ({
  shoppingListData,
  selectedShopListName,
  selectedShopListId,
  userId,
  role,
  ownerId,
  ownerName,
  type,
  notify,
  componentName,
  slidesToShow = 5,
}) => {
  const location = useLocation();
  const { user } = UserAuth();
  const { uid } = useParams();
  const isSmallScreen = window.innerWidth < 768;
  console.log("shoppingListData in product list", shoppingListData);
  const selectedShopListData = shoppingListData.find(
    (shopList) =>
      shopList.name === selectedShopListName &&
      shopList.listId === selectedShopListId
  );
  console.log("selectedShopListData in product list", selectedShopListData);

  return (
    <div
      className={`card-body p-0 bg-mode row mx-0`}
      style={{ marginTop: "0px" }}
      // style={{ overflow: "auto hidden", whiteSpace: "nowrap" }}
    >
      {shoppingListData?.some(
        (shopList) =>
          shopList.name === selectedShopListName && shopList.products.length > 0
      ) ? (
        <>
          {shoppingListData
            .filter(
              (shopList) =>
                shopList.name === selectedShopListName &&
                shopList.listId === selectedShopListId
            )
            .flatMap((shopList) =>
              shopList.products.map((product, index) => (
                <ShoppingListCard2
                  product={product}
                  id={shopList.id}
                  listName={shopList.name}
                  shoppingListData={shoppingListData}
                  userId={userId}
                  role={role}
                  listId={selectedShopListId}
                  ownerId={ownerId}
                  key={index}
                  type={type}
                  notify
                />
              ))
            )}
        </>
      ) : (
        <div style={{ height: "23rem", maxHeight: "25rem" }}>
          <div
            className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
            style={{
              minHeight: "10vh", // Make it fill the full viewport height
              height: "25rem",
              maxHeight: "25rem",
              width: "100%",
              gap: "24px",
            }}
          >
            <svg
              // style={{ width: "110px" }}
              width="141"
              height="141"
              viewBox="0 0 141 141"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="2"
                width="137"
                height="137"
                rx="68.5"
                stroke="#676A79"
                stroke-width="3"
              />
              <path
                d="M62.9916 53.4545C62.9916 50.0279 66.0821 47.25 69.8947 47.25C73.7069 47.25 76.7977 50.0279 76.7977 53.4545C76.7977 55.0673 76.2149 56.5363 75.2006 57.6397C73.2581 59.7529 70.3549 61.8814 70.3549 64.6229V65.5472M70.3549 65.5472C72.7322 65.5195 75.119 66.1799 77.1246 67.5319L84 72.1664M70.3549 65.5472C67.997 65.5745 65.6485 66.2787 63.6907 67.6558L40.6298 83.8775C36.4955 86.7856 38.7834 92.75 44.0333 92.75H97.9669C103.274 92.75 105.526 86.6774 101.28 83.8154L93.75 78.7392"
                stroke="#676A79"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>

            <div
              style={{
                whiteSpace: "normal",
                width: "100%",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "24px",
                color: "#676A79",
                textAlign: "center",
                // padding: "0 20rem",
              }}
            >
              No products Yet
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductList2;
